import React from 'react';
import Media from 'react-media';
import styled from 'styled-components';

import { IProduct } from 'models';
import { BackButton, BackButtonCompact, NextButton, NextButtonCompact } from '../step/NavigationButton';

interface IProps {
  selectedProduct: IProduct | null;
  onMakeContactRequestPressed: () => void;
  onBackPressed: () => void;
  onResetPressed: () => void;
}

const FinalPageUpperContainer = styled.div`
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      flex-direction: row;
    `;

const FinalPageUpperContainerCompact = styled.div`
      display: flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      flex-direction: column;
    `;

const Divider = styled.div`
      width: 100%;
      height: 1px;
      background-color: #000000;
    `;

const Button = styled.input`
      background-color: #FF7203;
      margin: 4px;
      height: 38px;
      width: 280px;
      border: none;
      color: white;
      text-align: center;
      text-decoration: none;
      font-size: calc(0.4em + 0.4vw);
      font-weight: bold;

      :hover {
        cursor: pointer;
      }
    `;

const ButtonCompact = styled.input`
      background-color: #FF7203;
      margin: 4px;
      height: 30px;
      width: 180px;
      border: none;
      color: white;
      text-align: center;
      text-decoration: none;
      font-size: calc(0.4em + 0.4vw);
      font-weight: bold;

      :hover {
        cursor: pointer;
      }
    `;

const ProductNameTitle = styled.h2`
      font-size: calc(0.8em + 0.4vw);
    `;

const TechDataHeader: React.FC<IProps> = (
  {
    selectedProduct,
    onBackPressed,
    onMakeContactRequestPressed,
    onResetPressed
  }) => {
  function getProductModelUrl() {
    const baseUrl = 'https://www.wartsila.com/marine/products/engines-and-generating-sets';

    if (selectedProduct === null) return baseUrl;

    let productFamilyId = '';
    let productType = '';

    const dualFuelOrGasEngineIdLength = 4;
    const fuelEngineIdLength = 3;
    const defaultEngineIdLength = 2;
    const dualFuelProductType = 'dual-fuel-engines';

    if (selectedProduct.name.includes('32M')) {
        return 'https://www.wartsila.com/marine/products/engines-and-generating-sets/wartsila-32-methanol-engine';
    }

    if (selectedProduct.name.includes('TSDF')) {
        productFamilyId = '46ts-df';
        productType = dualFuelProductType;
    } else if (selectedProduct.name.includes('25')) {
        productFamilyId = '25';
        productType = dualFuelProductType;
    } else {
      if (selectedProduct.name.includes('DF') || selectedProduct.name.includes('SG')) {
        productFamilyId = selectedProduct.name.slice(selectedProduct.name.length - dualFuelOrGasEngineIdLength);
        productType = selectedProduct.name.includes('DF') ? 'dual-fuel-engines' : 'pure-gas-engines';
      } else {
        if (selectedProduct.name.slice(selectedProduct.name.length - dualFuelOrGasEngineIdLength).includes('F')) {
          productFamilyId = selectedProduct.name.slice(selectedProduct.name.length - fuelEngineIdLength);
        } else {
          productFamilyId = selectedProduct.name.slice(selectedProduct.name.length - defaultEngineIdLength);
        }
        productType = 'diesel-engines';
      }
    }

    return `${baseUrl}/${productType}/wartsila-${productFamilyId}`;
  }

  return (
    <div>
      <FinalPageUpperContainer>
        <ProductNameTitle>
          YOUR PRODUCT: {selectedProduct != null ? selectedProduct.name : ''}
        </ProductNameTitle>

        <Media query="(min-width: 840px)">
          {(matches) =>
            matches ? (
              <FinalPageUpperContainer>
                <form action={getProductModelUrl()} target="_blank">
                  <Button type="submit" value="PRODUCT GUIDES & 3D DRAWINGS" />
                </form>
                <Button type="submit" value="MAKE A CONTACT REQUEST" onClick={() => onMakeContactRequestPressed()} />
              </FinalPageUpperContainer>
            )
              : (
                <FinalPageUpperContainerCompact>
                  <form action={getProductModelUrl()} target="_blank">
                    <ButtonCompact type="submit" value="PRODUCT GUIDES & 3D DRAWINGS" />
                  </form>
                  <ButtonCompact
                    type="submit"
                    value="MAKE A CONTACT REQUEST"
                    onClick={() => onMakeContactRequestPressed()}
                  />
                </FinalPageUpperContainerCompact>
              )}
        </Media>
        <Media query="(min-width: 840px)">
          {(matches) =>
            matches ? (
              <div>
                <BackButton
                  hidden={false}
                  onClick={() => onBackPressed()}
                  disabled={false}
                >
                  Back
                </BackButton>
                <NextButton
                  hidden={false}
                  onClick={() => onResetPressed()}
                  disabled={false}
                >
                  Restart
                </NextButton>
              </div>
            )
              : (
                <div>
                  <BackButtonCompact
                    hidden={false}
                    onClick={() => onBackPressed()}
                    disabled={false}
                  >
                    Back
                  </BackButtonCompact>
                  <NextButtonCompact
                    hidden={false}
                    onClick={() => onResetPressed()}
                    disabled={false}
                  >
                    Restart
                  </NextButtonCompact>
                </div>
              )}
        </Media>
      </FinalPageUpperContainer>
      <Divider />
    </div >
  );
};

export default TechDataHeader;
